import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Header from '../../components/Header/Header';
import appContext from '../../context/App';
import Notification from '../../components/Notification/Notification';
import { getMobileOperatingSystem } from '../../shared/helpers';

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        minHeight: getMobileOperatingSystem() === 'ios' ? '170vh' : '100vh'
    }
}));

const Layout = props => {
    const classes = useStyles();
    return (
        <appContext.AppContextProvider>
            <Header isAuthenticated={props.isAuthenticated}></Header>
            <div className={classes.mainContainer + " container py-3"}>
                {props.children}
            </div>
            <Notification />
        </appContext.AppContextProvider>
    )
}

export default Layout;